<template>
    <div class="read-more">
        <p class="read-more__text">
            {{paragraph}}
            <span v-cloak @click="toggle" v-if="!expanded && more" class="read-more__actions">Read More</span>
            <span v-cloak @click="toggle" v-else-if="expanded" class="read-more__actions">Less</span>
        </p>
    </div>
</template>

<script>
export default {
    name: 'ReadMore',
    props: {
        text: String,
        maxChar: {
            typs: Number,
            default: 20,
        },
        maxCharMD: {
            typs: Number,
            default: 20,
        },
        maxCharSM: {
            typs: Number,
            default: 20,
        },
    },
    data() {
        return {
            expanded: false,
            charMaxLen: this.maxChar
        }
    },
    mounted() {
        this.$nextTick(function() {
            window.addEventListener('resize', this.getWindowWidth);
            this.getWindowWidth()
        })
    },
    destroyed() {
        window.removeEventListener('resize', this.getWindowWidth)
        this.getWindowWidth()
    },
    computed: {
        formattedText() {
            let text = this.text
            if(this.text.length > this.maxChar) {
                return text.substring(0, this.charMaxLen) + "...";
            }
            return text
        },
        more() {
            return this.text.length > this.maxChar
        },
        paragraph() {
            return this.expanded ? this.text : this.formattedText
        },
    },
    methods: {
        toggle() {
            this.expanded = !this.expanded
        }, 
        getWindowWidth() {
            let winWith = document.documentElement.clientWidth
            if(winWith < 576) {
                this.charMaxLen = this.maxCharSM
            }
            else if(576 < winWith < 768) {
                this.charMaxLen = this.maxCharMD
            }
        }
    }
}
</script>

<style lang="scss">
:root {
    --readmore-font-size: 16px;
    --readmore-line-height: 24px;
    --readmore-text-color: #333333;
    --readmore-actions-color: #727CF5;
}
</style>
<style lang="scss" scoped>
[v-cloack] {
    display: none;
}
.read-more {
    &__text {
        margin-bottom: 0;
        color: var(--readmore-text-color);
        font-size: var(--readmore-font-size);
        line-height: var(--readmore-line-height);
    }
    &__actions {
        color: var(--readmore-actions-color);
        font-size: var(--readmore-font-size);
        font-family: 'Eina SemiBold';
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>